/**

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

 * Pagination Module - Управление постраничной навигацией
 */

(function(window) {
    'use strict';

    const Pagination = {};

    /**
     * Инициализирует пагинацию
     */
    Pagination.init = function(options = {}) {
        const {
            totalPages,
            currentPage = 1,
            maxPages = 10000,
            container = '.pages',
            onPageChange = null
        } = options;

        if (totalPages <= 1) {
            return; // Пагинация не нужна
        }

        // Получаем текущую страницу из URL
        let page = Pagination.getCurrentPageFromUrl();
        if (page > maxPages) page = maxPages;
        if (page < 1) page = 1;

        if (debugMode === '1') {
                console.log(`currentPage=${page}`);
            }

        // Legacy pagination plugin removed - this function is now a stub
        // Pagination is handled by renderFulltextPagination() in app-initialization.search.js
        if (debugMode === '1') {
            console.log('[Pagination] Legacy init called but plugin removed - using custom pagination');
        }
    };

    /**
     * Получает текущую страницу из URL
     */
    Pagination.getCurrentPageFromUrl = function() {
        try {
            const pageParam = $.urlParam('fnd_page');
            const page = Number(pageParam);
            return (page > 0) ? page : 1;
        } catch (e) {
            return 1;
        }
    };

    /**
     * Настраивает обработчики событий для пагинации
     */
    Pagination.setupEventHandlers = function(container, totalPages) {
        const activePage = Number($('.paginat .pgs-page.active a').text());
        
        // Удаляем старые обработчики событий
        const el = $(container)[0];
        if (el) {
            const elClone = el.cloneNode(true);
            el.parentNode.replaceChild(elClone, el);
        }

        // Скрываем стрелки на крайних страницах
        if (activePage === 1) {
            $(".paginat .pgs-prev").addClass("d-none");
        } else if (activePage === totalPages) {
            $(".paginat .pgs-next").addClass("d-none");
        }

        // Добавляем классы и атрибуты
        $('.paginat a').addClass('page-link').each(function() {
            const $this = $(this);
            const parent = $this.parent();
            let pageNumber = 1;

            if (parent.hasClass("pgs-prev")) {
                pageNumber = activePage - 1;
            } else if (parent.hasClass("pgs-next")) {
                pageNumber = activePage + 1;
            } else {
                pageNumber = Number($this.text());
            }

            $this.attr("page-number", pageNumber.toString());
        });

        // Обработчик клика по странице
        $('.paginat a').click(function(e) {
            e.preventDefault();
            const pageNumber = $(this).attr("page-number");
            Pagination.navigateToPage(pageNumber);
        });
    };

    /**
     * Переходит на указанную страницу
     */
    Pagination.navigateToPage = function(pageNumber) {
        let url = window.location.href;
        
        // Обновляем параметр fnd_page в URL
        if (url.search(/\bfnd_page=/) > -1) {
            url = url.replace(/\bfnd_page=\d*/, 'fnd_page=' + pageNumber);
        } else {
            // Добавляем параметр, сохраняя хэш в конце
            url = url.replace(/(#[^#]*)?$/, '&fnd_page=' + pageNumber + '$1');
        }
        
        if (debugMode === '1') {
                console.log('Navigating to:', url);
            }
        window.location.href = url;
    };

    /**
     * Обновляет состояние пагинации без перезагрузки страницы
     */
    Pagination.updateState = function(currentPage, totalPages) {
        // Обновляем активную страницу
        $('.paginat .pgs-page').removeClass('active');
        $('.paginat .pgs-page').each(function() {
            if ($(this).find('a').text() == currentPage.toString()) {
                $(this).addClass('active');
            }
        });

        // Обновляем видимость стрелок
        $(".paginat .pgs-prev, .paginat .pgs-next").removeClass("d-none");
        
        if (currentPage === 1) {
            $(".paginat .pgs-prev").addClass("d-none");
        } else if (currentPage === totalPages) {
            $(".paginat .pgs-next").addClass("d-none");
        }

        // Обновляем атрибуты page-number
        const activePage = currentPage;
        $('.paginat a').each(function() {
            const parent = $(this).parent();
            let pageNumber = 1;

            if (parent.hasClass("pgs-prev")) {
                pageNumber = activePage - 1;
            } else if (parent.hasClass("pgs-next")) {
                pageNumber = activePage + 1;
            } else {
                pageNumber = Number($(this).text());
            }

            $(this).attr("page-number", pageNumber.toString());
        });
    };

    /**
     * Уничтожает пагинацию
     */
    Pagination.destroy = function(container = '.pages') {
        // Legacy pagination plugin removed - just clear container
        $(container).empty();
    };

    /**
     * Вспомогательная функция для создания диапазона чисел
     */
    Pagination.range = function(start, end) {
        return Array.from({length: end - start + 1}, (_, i) => start + i);
    };

    // Экспорт модуля
    window.Pagination = Pagination;

    // Для обратной совместимости
    if (!Array.range) {
        Array.range = function(start, end) {
            return Pagination.range(start, end);
        };
    }

    // ES Module export for modern imports
    if (typeof window !== 'undefined') {
        window.paginationManager = Pagination;
    }

})(window); 

// ES Module export
    /**
     * ЗАГЛУШКИ для main-init.js API
     */
    Pagination.init = function(config) {
        return this;
    };

    Pagination.setTotalItems = function(count) {
        if (debugMode === '1') {
                console.log('[Pagination] setTotalItems called', count);
            }
        return this;
    };

    Pagination.onPageChange = function(callback) {
        this._pageChangeCallback = callback;
        return this;
    };

export const paginationManager = window.Pagination || {}; 